
import {computed, defineComponent, PropType} from 'vue';
import SequenceId from '@/utils/sequence-id';
import {useI18n} from 'vue-i18n';
import OverlayFilter, {
  supportPositions,
} from '@/image-processor/filters/overlay-filter';
import {supportTypes} from '@/image-processor';
import AbstractFilter from '@/image-processor/filters/abstract-filter';

type OverlayFilterProps = Omit<OverlayFilter, keyof AbstractFilter>;

export default defineComponent({
  props: {
    modelValue: {
      type: Object as PropType<OverlayFilterProps>,
      default: (): OverlayFilterProps => {
        return {
          position: supportPositions.MIDDLE_CENTER,
          margin: 0,
        };
      },
    },
  },
  emits: {'update:modelValue': (data: OverlayFilterProps) => !!data},
  setup(props, {emit}) {
    const componentID = SequenceId.getNew();
    const {t} = useI18n({useScope: 'global'});
    const margin = computed({
      get: () => props.modelValue.margin,
      set: value =>
        emit('update:modelValue', {...props.modelValue, margin: value}),
    });
    const position = computed({
      get: () => props.modelValue.position,
      set: value =>
        emit('update:modelValue', {...props.modelValue, position: value}),
    });

    const updateImage = (image?: File) => {
      emit('update:modelValue', {...props.modelValue, image});
    };

    const positionList = computed(() =>
      Object.entries(supportPositions)
        .filter(([position]) => isNaN(Number(position)))
        .map(([position, index]) => {
          return {text: position, value: index};
        })
    );

    const acceptImageTypeList = computed(() =>
      Array.from(supportTypes, type => type[0]).join(',')
    );

    return {
      t,
      componentID,
      margin,
      position,
      positionList,
      acceptImageTypeList,
      updateImage,
    };
  },
});
